export default __webpack_public_path__ + "static/hourra-illus-1af4be18dccf59cf728afbcc03ae9918.svg";